import { AbstractEntity } from "./abstract-entity.model";

export class SearchLogClickHistoryModel extends AbstractEntity {
    productName: string;
    productId: number;
    uuid: string;
    marketUserId: number;
    costType: string;
    searchLogId;
    viewType: string;
    info: string;
}